
import { MapLocation } from '@/types/location';

// Elite Arena Gym Locations
export const eliteArenaGyms: MapLocation[] = [
  {
    id: 33001,
    name: "Elite Arena - Riyadh (Al Qadisiyah)",
    type: "Gym",
    devices: 1,
    coordinates: [24.794089870100397, 46.78748294283849],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "15-47",
    orientation: "Portrait",
    segment: "Fitness"
  }
];
